import dd from 'dingtalk-jsapi'
// 钉钉容器内title渲染，先判断是否钉钉容器，再将传进来的参数进行标题渲染
export const setDDTitle = (t) => {
  if (dd.env.platform !== 'notInDingTalk') {
    dd && dd.biz.navigation.setTitle({
      title: t,
    })
  }
}
